import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';

export class SharePointWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.sharepoint.ID;
        this.name = DatabaseEnum.sharepoint.NAME;
        this.code = DatabaseEnum.sharepoint.CODE;
        this.equivalentTag = DatabaseEnum.sharepoint.EQUIVALENT_TAG;
        this.showLoadPropertiesTab = true;
        this.showExtractPropertiesTab = true;
        this.showDatabaseTab = true;
        this.hideSchemaNmColumn = false;
        this.isFileType = true;
        this.isNeedRedirectForTestDP = false;
        this.disableTestDataPointButton = false;
        this.showDataDescription = false;
        this.importFileProperties();
        this.dataObjectConnDatabaseNm = 'site';this.conn_DbsTabName = 'site';

        this.databaseNm="SITE"
          // data object tabs
        //   this.showDataObjectPropertiesTab = false;
        //   this.showViewDataTabOption = false;
        //   this.showDDLOption = false;
        //   this.isShowObjProperties = false;
        //   this.dataObjectConnDatabaseNm = 'Database';
        //   this.isFileType = false;
        //   this.showPropertiesTab = false;

    }


    validateRepConn(repConnWrapper: RepConnWrapper): void {

        // if (String(repConnWrapper.repConn.conn.batchSize) == 'null' ||
        //     String(repConnWrapper.repConn.conn.batchSize) == '') {
        //     repConnWrapper.inValid_Cds.push('ESM00671');
        // } else if (String(repConnWrapper.repConn.conn.timeOut) == 'null' ||
        //     String(repConnWrapper.repConn.conn.timeOut) == '') {
        //     repConnWrapper.inValid_Cds.push('ESM00672');
        // }
        // if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
		// 	repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
		// }

		// if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
		// 	repConnWrapper.inValid_Cds.push('NO_PASSWORD');
		// }

        /*else if( repConnWrapper.repConn.conn.accessToken == '' ){
            repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
        }*/


        //  if (repConnWrapper.repConn.conn.access_Token_Flg == 'Y') {

            if (repConnWrapper.repConn.conn.secToken == "") {
                repConnWrapper.inValid_Cds.push('TEN_ID');
            }

            if (repConnWrapper.repConn.conn.consumerKey == "") {
                repConnWrapper.inValid_Cds.push('CLI_ID');
            }

            if (repConnWrapper.repConn.conn.consumerSecret == "") {
                repConnWrapper.inValid_Cds.push('SEC_ID');
            }

        //       if (repConnWrapper.repConn.conn_Dbs[0]== "") {
        //     repConnWrapper.inValid_Cds.push('NO_SITE');
        // }
        //  }
        // if (repConnWrapper.repConn.conn.accessToken == "") {
        //     repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
        // }
        // if (repConnWrapper.repConn.conn.accessTokenSecret == "") {
        //     repConnWrapper.inValid_Cds.push('REFRESH_TOKEN');
        // }
        if (repConnWrapper.repConn.conn_Dbs.length != 0) {
            if (repConnWrapper.repConn.conn_Dbs[0].databaseNm == "") {
                repConnWrapper.inValid_Cds.push('NO_DATABASE_NM');
            }
        }
        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }
    }

    importFileProperties() {
        this.showFileTypeGroup = true;
        this.showDelimiter = true;
        this.showFixedWidth = true;
    }

    readFileCutOffLength(type: string): number {
        if (type == "FILE") {
            return 49; //default 50 lines index starts from 0
        }

        return -1;
    }

}
